export default __webpack_public_path__ + "static/media/Short.bf6299a6.mp3";